module.exports = __webpack_public_path__ + "static/media/pin.fd36011c.svg";